import { theme } from '@by-miles/bymiles-styles'
import styled from 'styled-components'

const {
  grid: { spacing, resolution },
} = theme

export const DriversTabGroupStyle = styled.div`
  margin-top: ${spacing.md}px;

  @media (min-width: ${resolution.desktop.width}px) {
    margin-top: ${spacing.l}px;
  }
`
